import Container from '@/components/Container';

const ResourceHubDetailLoading = () => (
  <>
    <div className="w-full bg-light-green py-sh-60">
      <Container>
        <div className="col-span-12">
          <div className="flex flex-col gap-[8px]">
            <div className="h-9 w-36 animate-pulse rounded bg-gray-200" />
            <div className="h-6 w-24 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="my-[12px] flex items-start justify-between gap-2">
            <div className="h-9 w-3/4 max-w-xl animate-pulse rounded bg-gray-200" />
            <div className="mt-sh-15 h-10 w-10 shrink-0 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </Container>
    </div>
    <Container>
      <div className="col-span-12 mt-[64px]">
        <div className="mb-[32px] h-8 w-48 animate-pulse rounded bg-gray-200" />
        <div className="mb-sh-15 h-5 w-full max-w-2xl animate-pulse rounded bg-gray-200" />
      </div>
      <div className="col-span-12 flex flex-col gap-y-sh-30">
        <div className="h-96 w-full animate-pulse rounded-2xl bg-gray-200" />
        <div className="h-8 w-2/3 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-4/5 animate-pulse rounded bg-gray-200" />
        <div className="h-4 w-3/4 animate-pulse rounded bg-gray-200" />
        <div className="rounded-sh-16 border border-gray-200 p-6">
          <div className="mb-sh-15 h-6 w-40 animate-pulse rounded bg-gray-200" />
          <div className="mb-sh-15 h-20 w-full animate-pulse rounded bg-gray-200" />
          <div className="flex gap-4">
            <div className="h-10 w-32 animate-pulse rounded bg-gray-200" />
            <div className="h-10 w-32 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="mt-sh-30 border-t border-people-gray-200 pt-[16px]">
          <div className="h-5 w-36 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </Container>
  </>
);

export { ResourceHubDetailLoading };
